import { CountProps, useCount } from '@/components/count';
import { cn } from '@/utils/shadcn';
import { FormattedMessage } from 'react-intl';
type CountTagProps = CountProps & {
  message?: string;
  className?: string;
};

export function CountTag({
  apiEndpoint,
  params,
  message = 'counts.nRecords',
  property,
  className,
}: CountTagProps) {
  const { count } = useCount({ apiEndpoint, params, property });

  if (typeof count === 'number' && count > 0) {
    return (
      <Tag className={className}>
        <FormattedMessage id={message} values={{ total: count }} />
      </Tag>
    );
  }

  return false;
}

export function Tag({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <span
      className={cn(
        'g-align-middle g-bg-slate-300/50 g-text-slate-800 g-text-xs g-font-medium g-px-2.5 g-py-0.5 g-rounded',
        className
      )}
    >
      {children}
    </span>
  );
}
